"use client";

import React, { FunctionComponent } from "react";

const getDayNumber = (date: Date) => {
  if (!date) return;

  const formatted = new Date(date);

  const newFormatted = formatted?.toLocaleDateString("hr-HR", {
    day: "numeric",
  });

  if (newFormatted?.length === 2) return "0" + newFormatted;

  return newFormatted.replace(".", "");
};

const getMonth = (date: Date) => {
  if (!date) return;

  const formatted = new Date(date);

  const newFormatted = formatted?.toLocaleDateString("hr-HR", {
    month: "long",
  });

  if (newFormatted?.length === 2) return "0" + newFormatted;

  return newFormatted;
};

const getYear = (date: Date) => {
  if (!date) return;

  const formatted = new Date(date);

  return formatted?.toLocaleDateString("hr-HR", {
    year: "numeric",
  });
};

export const EventDate: FunctionComponent<{ date: any }> = (date) => {
  if (!date?.date) return;

  return (
    <div>
      {getDayNumber(date?.date)} {getMonth(date?.date)} {getYear(date?.date)}
    </div>
  );
};
